module.exports = __webpack_public_path__ + "static/media/Lima-logo200x200.f2616ae5.png";